import React from "react";

function FormLineMedium6(props) {

  return (
    <div
      className={
        props.color === "1"
          ? "formLineMedium6 light-grey-form"
          : "formLineMedium6 grey-form"
      }
    >
      <div className="role-line-block1">{props.userEmail}</div>
      <div className="role-line-block1">{props.userName}</div>
      <div className="role-line-block1bis">{props.userRole}</div>
      <div className="role-line-block1bis">{props.userPhone}</div>
    </div>
  );
}

export default FormLineMedium6;
